import React, { ReactElement } from "react";
import { useAuth } from "@src/contexts/AuthProvider";
import { Navigate, RouteProps } from "react-router-dom";
import { Page } from "@src/shared/pages";
import { updateStorageLoginRedirect } from "@src/utils/session-storage";

export function PrivateRoute({ children }: RouteProps): ReactElement {
  const { tokenUserData, vendorUser } = useAuth();

  if (!tokenUserData && !vendorUser) {
    updateStorageLoginRedirect(
      `${window.location.pathname}${window.location.search}`,
    );
    return <Navigate to={Page.LOGIN} replace />;
  }

  if (vendorUser) {
    return <Navigate to={Page.VENDOR_PORTAL_HOME} />;
  }

  updateStorageLoginRedirect("");
  return children as ReactElement;
}
